import Checkbox from "../../gui/Button/Checkbox"
import { UpdateEvent } from "../../gui/GUIEvents"
import Dot3Icon from "../../gui/Icons/Dot3Icon"
import { TMenuRow } from "../../gui/Menu/Menu"
import MenuButton from "../../gui/Menu/MenuButton"
import { usePath } from "../../libs/path/PathProvider"
import PortAccount from "../../models/PortAccount"
import PortUtils from "../../portlibs/PortUtils"
import AccountFilter from "./AccountFilter"
import SearchFilter, { TSearchFilterProps } from "./SearchFilter"

export type TToolbarProps = TSearchFilterProps & {
    children?:React.ReactNode
    options?:TMenuRow<string>[]
    showAll?:boolean
}
export default function Toolbar(props:TToolbarProps){
    const {children,options,showAll,...searchProps} = props

    const {query,setQuery} = usePath()
    const {showDisposed} = PortUtils.getFilter(query)
    const onLogout = () => {
        PortAccount.i.logout()
    }
    const MenuOptions : TMenuRow<string>[] = [
        ...(options||[]),
        {id:"logout",text:"Logout",onClick:onLogout}
    ]
    const onAll = (e:UpdateEvent<boolean>) => setQuery({show:e.value ? "1" : null})
    return <div className="toolbar flex middle gap-8">
        <AccountFilter/>
        <SearchFilter {...searchProps}/>
        {children}
        {showAll ? <Checkbox value={showDisposed} onUpdate={onAll}>All</Checkbox> : <></>}
        <MenuButton menuProps={{options:MenuOptions}} className="icon"><Dot3Icon/></MenuButton>
    </div>

}